// data/UIUX/UIUXSkillsetData.js
// `visual` selects a pure-CSS/animated element from SkillsetVisual.jsx
// instead of a stock image — see src/components/SkillSetSection/SkillsetVisual.jsx.
const uiuxSkillsets = [
  {
    id: 1,
    visual: "mobile",
    title: "Responsives Design & Mobile First",
    description:
      "In einer Zeit, in der Internetzugriffe über unterschiedlichste Geräte erfolgen, sorgt responsives Design dafür, dass sich Anwendungen automatisch an jede Bildschirmgröße anpassen. Mit einer Mobile First Strategie erreichen Sie eine konsistente und zukunftssichere digitale Präsenz.",
  },
  {
    id: 2,
    visual: "browser",
    title: "Optimale Benutzererfahrung (UX)",
    description:
      "Exzellentes UX-Design ist heute unerlässlich. Intuitive, ansprechende Oberflächen steigern die Nutzerbindung, verbessern die Conversion-Raten und differenzieren Ihre Produkte im Markt – so wird Design zum entscheidenden Erfolgsfaktor.",
  },
  {
    id: 3,
    visual: "dashboard",
    title: "Effektive Benutzerforschung",
    description:
      "Durch gezielte Umfragen, Interviews und Beobachtungen gewinnen wir tiefe Einblicke in die Bedürfnisse Ihrer Zielgruppe. Diese Erkenntnisse fließen in alle Designentscheidungen ein und garantieren, dass Ihre Anwendungen nicht nur ästhetisch, sondern auch funktional und benutzerfreundlich sind.",
  },
];

export default uiuxSkillsets;
